// Path: ./src/app/components/ImageHoverTitle/index.tsx
import React, { useState, useRef } from "react";
import { TitleTooltip } from "../TitleToolTip";
import styled from "styled-components";

interface HoverDelayProps {
  text?: string;
  delay: number; // in milliseconds, after how much it show tooltip
  children: React.ReactNode;
}

export const ImageHoverTitleWrapper: React.FC<HoverDelayProps> = ({
  text,
  delay,
  children,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const timeoutRef = useRef<number | undefined>();

  const handleMouseEnter = () => {
    timeoutRef.current = window.setTimeout(() => {
      setIsVisible(true);
    }, delay);
  };

  const handleMouseLeave = () => {
    clearTimeout(timeoutRef.current);
    setIsVisible(false);
  };

  return (
    <Wrapper
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      data-testid="imagehovertitlewrapper-test-id"
    >
      {children}
      <TitleTooltip text={text} isVisible={isVisible} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
`;
